/**
 * Table caption ("header") treated as a toolbar.
 *
 * PrimeNG renders the `caption` template into `.p-datatable-header` /
 * `.p-treetable-header` and, by default, paints it `{content.background}` —
 * i.e. the same white as the table body. A caption that carries a filled search
 * field then reads as a stray grey box floating on white, because the field is
 * the only tinted thing in the row.
 *
 * Tinting the caption turns that row into a continuous toolbar: the search
 * field stops being an isolated blob, and the bar reads as a control strip
 * belonging to the table below it.
 *
 * The tint is deliberately {surface.50}, one step *lighter* than the filled
 * form field's {surface.100} (`--p-form-field-filled-background`). Matching the
 * field exactly would dissolve it into the bar, leaving only its Material
 * underline to signal an input; keeping one step of contrast lets the bar read
 * as a toolbar while the field still reads as a field.
 *
 * Only `background` is overridden — the stock token already ships
 * `borderWidth: '0 0 1px 0'`, so the bar is separated from the column headers
 * without any extra rule. The tint is the shared subtle surface
 * (`--p-bd-surface-subtle`, surface 50 / 800), see `bd-colors.ts`.
 */
export const TABLE_TOOLBAR_HEADER = {
  background: '{bd.surface.subtle}',
} as const;
